export function parseList(raw) {
    return (raw ?? '').split(/[\s,;]+/).map(s => s.trim()).filter(Boolean);
}
